import { render, staticRenderFns } from "./PurchaseForm.vue?vue&type=template&id=740543f0&scoped=true&"
import script from "./PurchaseForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseForm.vue?vue&type=style&index=0&id=740543f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740543f0",
  null
  
)

export default component.exports